//@flow
import { isEmpty } from "validator"
import type { AttractLoop } from "./types"

export default ({ title }: AttractLoop) => {
  const errors = {}
  if (!title || isEmpty(title)) {
    errors.title = "Cannot be blank"
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/AttractLoops/validate.js